function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import svgIcons from './svgIcons';
export var ICONS = Object.keys(svgIcons);
/**
 * SVG based icons that do not require loading any other assets (like icon fonts or images).
 */

export var Icon = forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, ["className", "name"]);

  var Svg = svgIcons[name];

  if (!Svg) {
    console.error('Invalid icon name', name);
    return null;
  }

  return React.createElement("span", _extends({
    className: "bbui-icon ".concat(className),
    ref: ref
  }, rest), React.createElement(Svg, null));
});
Icon.displayName = 'Icon';
export default styled(Icon).withConfig({
  displayName: "Icon",
  componentId: "az278c-0"
})(["display:inline-block;position:relative;vertical-align:-0.125em;svg{display:block;fill:currentColor;height:1em;width:1em;}"]);